import { render, staticRenderFns } from "./AppScrollbar.vue?vue&type=template&id=a6ed3aa0"
import script from "./AppScrollbar.vue?vue&type=script&lang=js"
export * from "./AppScrollbar.vue?vue&type=script&lang=js"
import style0 from "./AppScrollbar.vue?vue&type=style&index=0&id=a6ed3aa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports